"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trimCharacter = void 0;
var trimCharacter = function (str, char) {
    if (str.startsWith(char)) {
        return str.slice(char.length);
    }
    return str;
};
exports.trimCharacter = trimCharacter;
